import * as Yup from "yup";

export const verifyValidationSchema = Yup.object().shape({
  fullName: Yup.string().required("Họ tên không được để trống"),
  dob: Yup.string().required("Ngày sinh không được để trống"),
  id: Yup.string().required("CCCD không được để trống"),
  issueDate: Yup.string().required("Ngày cấp không được để trống"),
  issuePlace: Yup.string().required("Nơi cấp không được để trống"),
  address: Yup.string().required("Địa chỉ không được để trống"),
  email: Yup.string().required("Email không được để trống"),
  phone: Yup.string().required("Số ĐT không được để trống"),
  isConfirmed: Yup.array().min(1, "Yêu cầu xác nhận"),
});

export const confirmAccountValidationSchema = Yup.object().shape({
  username: Yup.string()
    .trim()
    .min(6, "Username phải từ 6 đến 16 ký tự!")
    .max(16, "Username phải từ 6 đến 16 ký tự!")
    .required("Username không được để trống!"),
  email: Yup.string()
    .trim()
    .email("Email không đúng định dạng!")
    .required("Email không được để trống!"),
});

export const profileValidationSchema = Yup.object().shape({
  fullName: Yup.string().trim().required("Họ và tên không được để trống!"),
  phone: Yup.string()
    .matches(/^[0-9]{10}$/, "Số điện thoại phải bao gồm 10 chữ số!")
    .required("Số điện thoại không được để trống!"),
  province: Yup.string().required("Vui lòng chọn Tỉnh/Thành phố!"),
  ward: Yup.string().required("Vui lòng chọn Xã/Phường/Thị trấn!"),
  addressDetail: Yup.string()
    .trim()
    .min(6, "Địa chỉ phải từ 6 ký tự!")
    .max(100, "Địa chỉ không được quá 100 ký tự!")
    .required("Vui lòng nhập địa chỉ cụ thể!"),
});

// Thể hiện đúng regex của bạn: 6-16 ký tự, ít nhất 1 hoa, 1 thường, 1 số, 1 ký tự đặc biệt
const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,16}$/;

export const changePasswordValidationSchema = Yup.object().shape({
  password: Yup.string()
    .required("Mật khẩu mới không được để trống!")
    .matches(
      passwordRegex,
      "Mật khẩu từ 6-16 ký tự, bao gồm ít nhất một chữ hoa, một chữ thường, một số và một ký tự đặc biệt!"
    ),
  confirmPassword: Yup.string()
    .required("Vui lòng xác nhận lại mật khẩu!")
    .oneOf([Yup.ref("password")], "Mật khẩu xác nhận không khớp!"),
});
